/**
 * Branded boot splash — fades out smoothly when the app shell is ready.
 */
import { perfMarkEnd, perfMarkStart, perfTimeline } from '../utils/startupPerf';

const MIN_VISIBLE_MS = 400;
const MAX_VISIBLE_MS = 1800;
const FADE_MS = 280;

let dismissPromise = null;

function getSplashEl() {
  return typeof document !== 'undefined' ? document.getElementById('boot-splash') : null;
}

export function markBootSplashShown() {
  const el = getSplashEl();
  if (!el || el.dataset.shownAt) return;
  el.dataset.shownAt = String(performance.now());
  perfMarkStart('pwa.splashVisible');
}

export function dismissBootSplash() {
  if (dismissPromise) return dismissPromise;

  dismissPromise = new Promise((resolve) => {
    const el = getSplashEl();
    if (!el || el.dataset.dismissing === '1') {
      resolve();
      return;
    }

    const shownAt = Number(el.dataset.shownAt) || performance.now();
    const elapsed = performance.now() - shownAt;
    const delay = Math.min(
      Math.max(MIN_VISIBLE_MS - elapsed, 0),
      Math.max(MAX_VISIBLE_MS - elapsed, 0)
    );

    window.setTimeout(() => {
      el.classList.add('boot-splash--out');
      el.dataset.dismissing = '1';
      perfMarkEnd('pwa.splashVisible', 'pwa');
      perfTimeline('pwa.splashDismissed', 'pwa', { visibleMs: Math.round(performance.now() - shownAt) });

      window.setTimeout(() => {
        el.remove();
        resolve();
      }, FADE_MS);
    }, delay);
  });

  return dismissPromise;
}

/** Hard fallback — boot splash cannot block the app past maxVisible. */
export function forceDismissBootSplash() {
  const el = getSplashEl();
  if (!el) return;
  el.classList.add('boot-splash--out');
  el.dataset.dismissing = '1';
  window.setTimeout(() => {
    el.remove();
  }, FADE_MS);
}
